import { CuffaMeasurementUnitEnum, CuffaProductionTypeEnum } from "common/enums";

const PRODUCT_CATEGORIES: Record<string, CuffaMeasurementUnitEnum[]> = {
  FOLHOSAS: [
    CuffaMeasurementUnitEnum.QUILOGRAMAS,
    CuffaMeasurementUnitEnum.TONELADAS,
    CuffaMeasurementUnitEnum.UNIDADES,
  ],
  ANIMAIS: [CuffaMeasurementUnitEnum.CABECAS],
  PESCADO: [CuffaMeasurementUnitEnum.QUILOGRAMAS],
  ARTESANATO: [CuffaMeasurementUnitEnum.UNIDADES],
  LIQUIDOS: [
    CuffaMeasurementUnitEnum.LITROS,
    CuffaMeasurementUnitEnum.QUILOGRAMAS,
  ],
  DEFAULT: [
    CuffaMeasurementUnitEnum.QUILOGRAMAS,
    CuffaMeasurementUnitEnum.TONELADAS,
    CuffaMeasurementUnitEnum.LITROS,
    CuffaMeasurementUnitEnum.UNIDADES,
  ],
  ALL: [ // para produtos customizados
    CuffaMeasurementUnitEnum.QUILOGRAMAS,
    CuffaMeasurementUnitEnum.TONELADAS,
    CuffaMeasurementUnitEnum.UNIDADES,
    CuffaMeasurementUnitEnum.LITROS,
    CuffaMeasurementUnitEnum.CABECAS,
  ],
};

const FOLHOSAS_PRODUCTS = [
  "acelga",
  "agrião",
  "alface americana",
  "alface crespa",
  "alface lisa",
  "alface romana",
  "almeirão",
  "cebolinha verde",
  "chicória",
  "coentro",
  "couve comum",
  "couve manteiga",
  "flores",
  "hortelã",
  "mostarda",
  "repolho branco",
  "repolho roxo",
  "rúcula",
  "salsa",
  "taioba",
];

const LIQUID_PRODUCTS = [
  "cachaça",
  "melado",
  "óleo de andiroba",
  "óleo de babaçu",
  "óleo de buriti",
  "óleo de castanha",
  "óleo de copaíba",
  "suco de frutas",
  "mel de abelha",
  "própolis",
  "iogurte",
  "leite",
];

const ARTESANATO_PRODUCTS = [
  "artesanato",
  "artesanato com partes vegetais",
  "artesanato em barro",
  "artesanato em argila",
  "artesanato em fibra",
  "artesanato em madeira",
  "artesanato têxtil",
];

export const getAllowedUnits = (
  productName: string,
  productionType: CuffaProductionTypeEnum,
  isProcessed = false,
  productType: "PADRAO" | "CUSTOMIZADO" = "PADRAO"
): CuffaMeasurementUnitEnum[] => {
  const name = productName.toLowerCase();

  // 0. Se for produto customizado → libera tudo
  if (productType === "CUSTOMIZADO") {
    return PRODUCT_CATEGORIES.ALL;
  }

  // 1. Produção animal
  if (productionType === CuffaProductionTypeEnum.ANIMAL) {
    if (name.includes("peixe")) {
      return PRODUCT_CATEGORIES.PESCADO;
    }
    return PRODUCT_CATEGORIES.ANIMAIS;
  }

  // 2. Processados/beneficiados
  if (isProcessed) {
    if (ARTESANATO_PRODUCTS.some((item) => name.includes(item))) {
      return PRODUCT_CATEGORIES.ARTESANATO;
    }
    if (LIQUID_PRODUCTS.some((item) => name.includes(item))) {
      return PRODUCT_CATEGORIES.LIQUIDOS;
    }
    return PRODUCT_CATEGORIES.DEFAULT;
  }

  // 3. Vegetais in natura
  if (productionType === CuffaProductionTypeEnum.VEGETAL) {
    if (FOLHOSAS_PRODUCTS.some((folhosa) => name.includes(folhosa))) {
      return PRODUCT_CATEGORIES.FOLHOSAS;
    }
    return PRODUCT_CATEGORIES.DEFAULT;
  }

  // 4. Caso não encontre
  return PRODUCT_CATEGORIES.DEFAULT;
};
export const formatCurrency = (value: string): string => {
  const numericValue = value.replace(/\D/g, '');
  const formattedValue = (Number(numericValue) / 100).toFixed(2);
  return `R$ ${formattedValue.replace('.', ',')}`;
};
